module.exports = __webpack_public_path__ + "img/message-question-square.44d3f016.svg";